import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, switchMap, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';

// Routes d'auth elles-mêmes : jamais de header Authorization, et un 401 dessus ne doit
// jamais déclencher une tentative de refresh (boucle infinie sur /auth/refresh, ou refresh
// inutile sur un login qui a simplement échoué avec de mauvais identifiants).
const AUTH_EXCLUDED_URLS = ['/auth/token', '/auth/refresh', '/auth/register'];

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const isAuthRoute = AUTH_EXCLUDED_URLS.some(url => req.url.includes(url));

  const token = authService.getToken();
  const authReq = (token && !isAuthRoute)
    ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
    : req;

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status !== 401 || isAuthRoute || !authService.getRefreshToken()) {
        if (error.status === 401 && !isAuthRoute) authService.logout();
        return throwError(() => error);
      }

      return authService.refreshAccessToken().pipe(
        switchMap(() => {
          const newToken = authService.getToken();
          const retryReq = req.clone({ setHeaders: { Authorization: `Bearer ${newToken}` } });
          return next(retryReq);
        }),
        catchError(refreshError => {
          authService.logout();
          return throwError(() => refreshError);
        })
      );
    })
  );
};
